/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import {
  UsersListComp,
  Header,
  SettingsComp,
  EventTimelineModal,
} from '../components';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import {
  useSMPayoutGetContent,
  useSMPolicyListPage,
  useSMUpdateStatus,
  updateStatusMachine,
} from '@pages/PayoutListPage/machines';
import { PayoutListPageService } from '@pages/PayoutListPage/services';
import { ItemSpecMercuryWidget } from '@vlinder-web/item-spec-mercury-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { useLocation } from 'react-router-dom';

import { useEventId } from '@pages/PayoutListPage/provider';

const getSrv = () => {
  return vappContainer.get<PayoutListPageService>(
    PayoutListPageService.displayName
  );
};

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export const ContainerComm = (props: any) => {
  const [buttons, setButtons] = useState<any>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const { policyListPageMachine, policyListPageSend, policyListPageState } =
    useSMPolicyListPage({});
  const srv = getSrv();
  const { state } = useLocation();
  const { eventId } = useEventId();

  useEffect(() => {
    // srv?.resetCriteria();
  }, []);

  useEffect(() => {
    if (state?.detail) {
      //    srv?.getButtons(state?.detail)?.then((res)=>setButtons(res));
    }
  }, []);

  const { payoutPageMachine, payoutPageSend, payoutPageState } =
    useSMPayoutGetContent({});

  const { updateStatusMachine, updateStatusSend, updateStatusState } =
    useSMUpdateStatus({});

  const onHeroButtonClick = async (key: string) => {
    console.log(`event key`, key);
    if (key === 'timeLine') {
      if (!showModal) {
        setShowModal(true);
      }
    }
    if (key === 'approve') {
      const approveModal = await SwalWithBootstrapButtons.fire({
        title: 'Acknowledgement',
        html: `Approve Event for payout processing`,
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: 'Approve',
      });
      if (approveModal.isConfirmed) {
        updateStatusSend('START', {
          payload: {
            eventId: eventId,
            status: 'ACCEPTED',
          },
        });
      }
    }
    if (key === 'reject') {
      const { value: reason } = await SwalWithBootstrapButtons.fire({
        title: 'Acknowledgement',
        html: `Reject Event and stop payout processing`,
        input: 'textarea',
        inputLabel: 'Reason',
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: 'Reject',
      });
      if (reason) {
        console.log(`reason for reject`, reason);
        updateStatusSend('START', {
          payload: {
            eventId: eventId,
            status: 'REJECTED',
            reason: reason,
          },
        });
      }
      // else{
      //   updateStatusSend("START", {
      //     payload: {
      //       eventId:eventId,
      //       status:"INVALID",
      //     },
      //   });
      // }
    }
  };

  const onGoBack = () => {
    //history.goBack();
  };

  const onRefresh = () => {
    policyListPageSend('REFRESH_POLICY_LIST', {});
    setRefreshPagination(new Date());
  };

  const onClearFilter = () => {
    // srv?.resetCriteria();
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    policyListPageSend('REFRESH_POLICY_LIST', {});
  };

  const _renderNotification = () => {
    if (updateStatusState?.matches('UPDATE_STATUS_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticPagePayoutListSync()?.notifications
            ?.updateStatus || {})}
          onAcknowledgement={onGoBack}
          onDeny={onGoBack}
        />
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    policyListPageSend('REFRESH_POLICY_LIST', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    return (
      <Paginate
        {...(policyListPageState?.event?.data?.value || {})}
        onPageChange={onPaginationChange}
        key={refreshPagination}
        totalItems={policyListPageState?.event?.data?.value?.ultUsers?.length}
      />
    );
  };

  const onApplyFilter = (data: any) => {
    console.log('apply clicked', data);
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });

    console.log('filter Data', criteria);
    policyListPageSend('REFRESH_POLICY_LIST', {
      where: criteria,
    });
  };

  const onViewDetailClick = (rowData: any) => {
    props?.onViewDetailClick &&
      props?.onViewDetailClick(rowData, state?.detail);
  };

  const _renderPayoutList = () => {
    if (policyListPageState?.matches('GET_POLICY_LIST')) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticPagePayoutListSync()?.loading
            ?.retrieveCredentials || {})}
        />
      );
    }

    if (policyListPageState?.matches('GET_POLICY_LIST_SUCCESS')) {
      console.log(`policy list1::`, policyListPageState?.event?.data?.value);
      return (
        <>
          {policyListPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(srv?.agent?.getStaticPagePayoutListSync()?.loading
                ?.credentialListEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(policyListPageState?.event?.data?.value || {})}
              onViewDetailClick={onViewDetailClick}
              onRowClick={onViewDetailClick}
            />
          )}
        </>
      );
    }
    return null;
  };

  const _getPolicyList = () => {
    console.log(`state detail:`, state?.detail);
    const eventDetail = srv?.agent?.getEventDetailProps(state?.detail);
    if (updateStatusState?.matches('UPDATE_STATUS')) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticPagePayoutListSync()?.loading
            ?.updateStatus || {})}
        />
      );
    }
    //if(eventDetail){
    return (
      <>
        {_renderHeader()}
        {/* <ItemSpecMercuryWidget {...eventDetail || {}} 
      buttons={buttons}
      onHeroButtonClick={onHeroButtonClick}
      /> */}
        {_renderSearch()}
        {_renderPayoutList()}
      </>
    );
    //  }
  };

  const _renderModal = () => {
    console.log(`payout list page state`, payoutPageState?.event?.data?.value);
    if (showModal) {
      return (
        <EventTimelineModal
          showModal={showModal}
          modalTitle="Event Timeline"
          timelineData={payoutPageState?.event?.data?.value?.timeline}
          onDeny={() => {
            setShowModal(false);
          }}
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (payoutPageState?.matches('RENDER_PAYOUT_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticPagePayoutListSync()?.error?.formSubmit ||
            {})}
          onAcknowledgement={onGoBack}
          onDeny={onGoBack}
        />
      );
    }
    if (updateStatusState?.matches('UPDATE_STATUS_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticPagePayoutListSync()?.error?.updateStatus ||
            {})}
          onAcknowledgement={onGoBack}
          onDeny={onGoBack}
        />
      );
    }
    return null;
  };

  const _renderSearch = () => {
    return (
      <div className="mt-4">
        <SearchFilter
          // {...staticPageContentConfig?.settings}
          {...(srv?.agent?.getStaticPagePayoutListSync()?.settings || {})}
          onFilterApply={onApplyFilter}
          onClearFilter={onClearFilter}
        />
      </div>
    );
  };

  const _renderHeader = () => {
    if (srv?.agent?.getStaticPagePayoutListSync()?.header) {
      return (
        <>
          <Header
            {...(srv?.agent?.getStaticPagePayoutListSync()?.header || {})}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    return (
      <>
        {_getPolicyList()}
        {_renderPagination()}
        {/* {_renderErrorModals()} */}
        {/* {_renderNotification()} */}
        {_renderModal()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
